<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = '' }: Props = $props();
</script>

<div class={className}>
	<svg viewBox="3 3 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.41566 17H9.86455L10.5116 14.5H12.0634L11.4164 17H12.8653L13.5123 14.5H16V13H13.9006L14.4182 11H16.5V9.50002H14.8064L15.4535 7H14.0046L13.3575 9.50002H11.8057L12.4527 7H11.0038L10.3568 9.50002H8V11H9.96856L9.45093 13H7.5V14.5H9.0627L8.41566 17ZM11.4175 11L10.8998 13H12.4002L12.9693 11H11.4175Z"
			fill="currentColor"
		></path>
	</svg>
</div>
